(function(){"use strict";var reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;(!("animate"in document.body)||reduce)&&document.documentElement.classList.add("no-motion");var SPRING="cubic-bezier(.16,1,.3,1)",nodes=[].slice.call(document.querySelectorAll("[data-anim]"));if(!reduce&&"IntersectionObserver"in window){var seen=new Map;nodes.forEach(function(el){var p=el.parentElement,i2=seen.get(p)||0;seen.set(p,i2+1),el.style.transitionDelay=Math.min(i2,5)*70+"ms"});var io=new IntersectionObserver(function(entries){entries.forEach(function(e){e.isIntersecting&&(e.target.classList.add("in"),io.unobserve(e.target))})},{rootMargin:"0px 0px -10% 0px",threshold:.1});nodes.forEach(function(el){io.observe(el)})}else nodes.forEach(function(el){el.classList.add("in")});var hdr=document.getElementById("hdr"),bar=document.getElementById("buybar"),hero=document.querySelector(".hero")||document.querySelector(".pdp"),ticking=!1;function onScroll(){ticking||(ticking=!0,requestAnimationFrame(function(){var y=window.scrollY;hdr&&hdr.classList.toggle("stuck",y>12),bar&&bar.classList.toggle("on",y>(hero?hero.offsetHeight*.75:500)),ticking=!1}))}window.addEventListener("scroll",onScroll,{passive:!0}),onScroll();var rots=document.querySelectorAll("#rot span");if(rots.length>1&&!reduce){var i=0;setInterval(function(){rots[i].classList.remove("on"),i=(i+1)%rots.length,rots[i].classList.add("on")},3600)}document.querySelectorAll(".faq-item").forEach(function(item){var btn=item.querySelector(".faq-q"),panel=item.querySelector(".faq-a");btn.addEventListener("click",function(){var open=item.classList.toggle("open");btn.setAttribute("aria-expanded",open?"true":"false");var h=panel.firstElementChild.offsetHeight;if(reduce){panel.style.height=open?"auto":"0";return}panel.animate(open?[{height:"0px"},{height:h+"px"}]:[{height:h+"px"},{height:"0px"}],{duration:open?380:260,easing:SPRING,fill:"forwards"})})}),document.querySelectorAll(".vid").forEach(function(card){var v=card.querySelector("video"),b=card.querySelector(".ply");!v||!b||(b.addEventListener("click",function(){document.querySelectorAll(".vid.playing").forEach(function(o){o!==card&&(o.classList.remove("playing"),o.querySelector("video").pause())}),card.classList.add("playing"),v.play()}),v.addEventListener("pause",function(){v.currentTime>0&&!v.ended||card.classList.remove("playing")}),v.addEventListener("ended",function(){card.classList.remove("playing")}))});function hotspots(){var show=window.innerWidth>=620;document.querySelectorAll(".hot-label").forEach(function(l){l.style.display=show?"":"none"})}hotspots(),window.addEventListener("resize",hotspots,{passive:!0}),(function(){var main=document.querySelectorAll(".gal-main img"),thumbs=document.querySelectorAll("#thumbs button");thumbs.forEach(function(b,i2){b.addEventListener("click",function(){main.forEach(function(m,j){m.classList.toggle("on",i2===j)}),thumbs.forEach(function(t,j){t.setAttribute("aria-current",i2===j?"true":"false")})})});var q=document.getElementById("qty");if(!q)return;function step(d){q.value=Math.min(10,Math.max(1,(parseInt(q.value,10)||1)+d))}var minus=document.getElementById("q-"),plus=document.getElementById("q+");minus&&minus.addEventListener("click",function(){step(-1)}),plus&&plus.addEventListener("click",function(){step(1)})})(),(function(){var el=document.querySelector("[data-cart-count]");if(!el||!window.fetch)return;function draw(n){n>0?(el.textContent=n,el.hidden=!1):el.hidden=!0}fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.ok?r.json():null}).then(function(c){c&&draw(c.item_count)}).catch(function(){}),document.addEventListener("cart:refresh",function(){fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.ok?r.json():null}).then(function(c){c&&draw(c.item_count)}).catch(function(){})})})()})();
//# sourceMappingURL=/cdn/shop/t/5/assets/tribot.js.map?v=78694942412758802941787769754

/* ── Paket ürünlerde kapıda ödeme kapalı ──
   Paket fiyatları yalnızca kartla ön ödemede geçerli. Releasit'in
   "Kapıda Ödeme ile Satın Al" butonunu paket sayfasında ve sepette
   paket varsa gizle. (Uygulama tarafındaki ürün kısıtıyla birlikte
   çalışır; bu katman görsel/UX güvencesidir.) */
(function(){
  'use strict';
  var TIMER = null;
  function hideCod(){
    var n = document.querySelectorAll('#rsi_buy_now_button, [id^="rsi_buy_now_button"]');
    for (var i = 0; i < n.length; i++) { n[i].style.setProperty('display', 'none', 'important'); }
  }
  function keepHidden(){
    hideCod();
    if (TIMER) return;
    TIMER = setInterval(hideCod, 700);
    document.addEventListener('cart:refresh', hideCod);
  }
  function isBundleLine(i){
    return /PK$/.test(i.sku || '') || /paket/i.test(i.handle || '');
  }

  if (document.querySelector('[data-section="bundle-product"]')) { keepHidden(); }

  if (window.fetch) {
    var check = function(){
      fetch('/cart.js', {headers:{Accept:'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c && c.items && c.items.some(isBundleLine)) keepHidden(); })
        .catch(function(){});
    };
    check();
    document.addEventListener('cart:refresh', check);
  }
})();

/* ── Güvenlik ağı: görünen alandaki içerik asla gizli kalmasın ──
   IntersectionObserver ilk boyamada bazen tetiklenmiyor; bu durumda
   [data-anim] öğeleri opacity:0 takılı kalıyor. Ekranda olan her öğeye
   'in' sınıfını doğrudan ekleriz. */
(function(){
  var nodes = [].slice.call(document.querySelectorAll('[data-anim]'));
  if (!nodes.length) return;
  function reveal(){
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('in')) continue;
      var b = el.getBoundingClientRect();
      if (b.top < window.innerHeight && b.bottom > 0) el.classList.add('in');
    }
  }
  reveal();
  window.addEventListener('load', reveal);
  [120, 400, 900, 1800].forEach(function(t){ setTimeout(reveal, t); });
  window.addEventListener('scroll', reveal, {passive:true});
})();

/* ── Sabit satın alma çubuğu, gerçek butonların üstünü kapatmasın ──
   Mobilde .buybar ekranın altında sabit duruyor ve sayfadaki
   "Sepete Ekle" / "Kapıda Ödeme ile Satın Al" butonlarının üzerine
   biniyordu. Satın alma formu ekrandayken çubuğu gizliyoruz. */
(function(){
  'use strict';
  var bar = document.querySelector('.buybar');
  var form = document.querySelector('.tribot-buy-form') || document.querySelector('#satin-al .qty-row');
  if (!bar || !form) return;
  var over = false;
  function sync(){ bar.classList.toggle('is-hidden', over); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(e){
      over = e[0].isIntersecting;
      sync();
    }, {rootMargin: '0px 0px -40px 0px', threshold: 0}).observe(form);
  } else {
    window.addEventListener('scroll', function(){
      var b = form.getBoundingClientRect();
      over = b.top < window.innerHeight && b.bottom > 0;
      sync();
    }, {passive:true});
  }
})();

/* ── Sepete uçma animasyonu (yüzen balon yok; hedef üstteki sepet ikonu) ── */
(function(){
  'use strict';
  if (!window.fetch || !document.body) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var busy = false;

  var icon = document.querySelector('.hdr-cart');
  var nEl  = document.querySelector('[data-cart-count]');

  function refreshCount(){
    return fetch('/cart.js', {headers:{Accept:'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if (!c || !nEl) return;
        var n = c.item_count || 0;
        nEl.textContent = n;
        if (n > 0) { nEl.removeAttribute('hidden'); } else { nEl.setAttribute('hidden',''); }
      })
      .catch(function(){});
  }

  function fly(src, done){
    if (reduce || !src || !icon) { done(); return; }
    var a = src.getBoundingClientRect(), t = icon.getBoundingClientRect();
    if (!a.width || !t.width) { done(); return; }
    var g = src.cloneNode(true);
    g.className = 'cartfly';
    g.removeAttribute('srcset'); g.removeAttribute('sizes');
    g.style.left = a.left + 'px';
    g.style.top = a.top + 'px';
    g.style.width = a.width + 'px';
    g.style.height = a.height + 'px';
    document.body.appendChild(g);
    var dx = (t.left + t.width / 2) - (a.left + a.width / 2);
    var dy = (t.top + t.height / 2) - (a.top + a.height / 2);
    var an = g.animate([
      {transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0},
      {transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.45 - 60) + 'px) scale(.5)', opacity: .95, offset: .55},
      {transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06)', opacity: .2, offset: 1}
    ], {duration: 720, easing: 'cubic-bezier(.5,0,.35,1)'});
    an.onfinish = function(){ g.remove(); done(); };
    setTimeout(function(){ if (g.parentNode) { g.remove(); done(); } }, 880);
  }

  document.querySelectorAll('form.tribot-buy-form').forEach(function(f){
    /* Doğrudan ödemeye giden formlara (paket sayfaları) dokunma */
    if (f.querySelector('input[name="return_to"]')) return;
    var submit = f.querySelector('button[type="submit"]');
    f.addEventListener('submit', function(e){
      e.preventDefault();
      if (busy) return;
      busy = true;
      var label = submit ? submit.innerHTML : '';
      if (submit) { submit.classList.add('is-added'); submit.innerHTML = '✓ Sepete eklendi'; }

      var img = document.querySelector('.gal-main img.on') || document.querySelector('.gal-main img') || document.querySelector('.pdp-media img');
      fly(img, function(){});

      fetch('/cart/add.js', {method: 'POST', body: new FormData(f)})
        .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ return refreshCount(); })
        .then(function(){
          setTimeout(function(){
            if (submit) { submit.classList.remove('is-added'); submit.innerHTML = label; }
          }, 1800);
        })
        .catch(function(){ f.submit(); })
        .then(function(){ busy = false; });
    });
  });

  refreshCount();
})();

/* ── Ekranın dibindeki yabancı sabit çubuğu ölç (Releasit kapıda ödeme çubuğu)
   ve kendi sabit çubuklarımızı onun üstüne al. Uygulamanın kendi DOM'una
   dokunmuyoruz; sadece yüksekliğini ölçüp --codbar-h değişkenine yazıyoruz. */
(function(){
  'use strict';
  var root = document.documentElement;
  if (!root || !document.elementsFromPoint) return;
  var last = -1, timer = null;

  function mine(el){
    return !!(el.closest && el.closest('.buybar,.cartfly'));
  }

  function fixedBox(el){
    while (el && el.nodeType === 1 && el !== document.body) {
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { return null; }
      if (cs.position === 'fixed') return el;
      el = el.parentElement;
    }
    return null;
  }

  function measure(){
    var vh = window.innerHeight, vw = window.innerWidth, h = 0;
    var pts = [[vw * 0.5, vh - 3], [vw * 0.5, vh - 26], [vw * 0.28, vh - 3]];
    for (var p = 0; p < pts.length; p++) {
      var stack;
      try { stack = document.elementsFromPoint(pts[p][0], pts[p][1]) || []; }
      catch (e) { continue; }
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (!el || el === document.body || el === root || mine(el)) continue;
        var fx = fixedBox(el);
        if (!fx || mine(fx)) continue;
        var r = fx.getBoundingClientRect();
        if (r.height < 28 || r.height > 170) continue;   // çubuk boyutunda değil
        if (r.width < vw * 0.6) continue;                // dar yüzen buton (WhatsApp vb.)
        if (r.bottom < vh - 8) continue;                 // ekranın dibine yapışık değil
        if (r.height > h) h = r.height;
      }
    }
    h = Math.round(h);
    if (h !== last) {
      last = h;
      root.style.setProperty('--codbar-h', h + 'px');
    }
  }

  function schedule(){
    if (timer) return;
    timer = setTimeout(function(){ timer = null; measure(); }, 120);
  }

  measure();
  [300, 900, 2000, 4000, 7000].forEach(function(ms){ setTimeout(measure, ms); });
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('orientationchange', schedule, {passive: true});
  window.addEventListener('scroll', schedule, {passive: true});
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
})();
